import { c as _c } from "react/compiler-runtime";
import { Avatar, Badge, Box, HStack, Link, Text, VStack, Wrap } from '@chakra-ui/react';
import { SessionReviewStars } from '@src/components/sco/Advisors/reviews/SessionReviewStars';
import { sessionReviewAuthorHref, sessionReviewAuthorName, type SessionReviewItem } from '@src/components/sco/Advisors/reviews/sessionReviewHelpers';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import moment from 'moment';
import { ReactNode } from 'react';
export type SessionReviewCardProps = {
  review: SessionReviewItem;
  /**
   * Manage view (reviewee): show "Hidden" / "Hidden by Startups" / "Text hidden" markers and the
   * hidden text itself (dimmed). Public views leave this off — the backend already strips them.
   */
  showManageState?: boolean;
  /** Row actions (manage view). */
  actions?: ReactNode;
};

/** One review: author, stars, date, featured badge, text when present. */
export const SessionReviewCard = t0 => {
  const $ = _c(52);
  const {
    review,
    showManageState: t1,
    actions
  } = t0;
  const showManageState = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== review) {
    t2 = sessionReviewAuthorName(review);
    $[0] = review;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const name = t2;
  let t3;
  if ($[2] !== review.author) {
    t3 = sessionReviewAuthorHref(review.author);
    $[2] = review.author;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const href = t3;
  review.author?.tagline?.trim() || null;
  review.createdAt ? moment(review.createdAt).format("MMM D, YYYY") : null;
  const hidden = showManageState && (review.isHidden || review.isHiddenByAdmin);
  let t4;
  if ($[4] !== review.text) {
    t4 = review.text?.trim() || null;
    $[4] = review.text;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const text = t4;
  const t5 = `Review by ${name}`;
  const t6 = hidden ? "border.emphasized" : "colorPalette.border/50";
  const t7 = hidden ? "dashed" : "solid";
  const t8 = hidden ? "true" : undefined;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      base: 3,
      md: 4
    };
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== review.author) {
    t10 = review.author?.imageUrl ? <Avatar.Image alt="" src={review.author.imageUrl} /> : null;
    $[7] = review.author;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== name) {
    t11 = <Avatar.Fallback name={name} />;
    $[9] = name;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t10 || $[12] !== t11) {
    t12 = <Avatar.Root flexShrink={0} size="sm">{t10}{t11}</Avatar.Root>;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== href || $[15] !== name) {
    t13 = href ? <Link asChild={true} color="inherit" fontSize="sm" fontWeight="semibold"><NextLink href={href}>{name}</NextLink></Link> : <Text fontSize="sm" fontWeight="semibold">{name}</Text>;
    $[14] = href;
    $[15] = name;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Text fontSize="sm" fontWeight="normal" opacity={0.5}>rated</Text>;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== review.score) {
    t15 = <SessionReviewStars score={review.score} />;
    $[18] = review.score;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t13 || $[21] !== t15) {
    t16 = <HStack align="center" flexWrap="wrap" gap={2} minWidth={0}>{t13}{t14}{t15}</HStack>;
    $[20] = t13;
    $[21] = t15;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== review.isFeatured || $[24] !== review.isHidden || $[25] !== review.isHiddenByAdmin || $[26] !== review.isTextHidden || $[27] !== showManageState) {
    t17 = (review.isFeatured || showManageState && (review.isHidden || review.isHiddenByAdmin || review.isTextHidden)) && <Wrap gap={2}>{review.isFeatured && <Badge colorPalette="orange" size="sm" variant="subtle">Featured</Badge>}{showManageState && review.isHidden && <Badge colorPalette="gray" size="sm" variant="outline">Hidden from profile</Badge>}{showManageState && review.isHiddenByAdmin && <Badge colorPalette="red" size="sm" variant="outline">Hidden by Startups</Badge>}{showManageState && review.isTextHidden && <Badge colorPalette="gray" size="sm" variant="outline">Text hidden</Badge>}</Wrap>;
    $[23] = review.isFeatured;
    $[24] = review.isHidden;
    $[25] = review.isHiddenByAdmin;
    $[26] = review.isTextHidden;
    $[27] = showManageState;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t16 || $[30] !== t17) {
    t18 = <VStack align="flex-start" gap={1} minWidth={0}>{t16}{t17}</VStack>;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t12 || $[33] !== t18) {
    t19 = <HStack align="flex-start" gap={3} justify="space-between"><HStack align="center" flex={1} gap={3} minWidth={0}>{t12}{t18}</HStack></HStack>;
    $[32] = t12;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== hidden || $[36] !== review.isTextHidden || $[37] !== showManageState || $[38] !== text) {
    t20 = text && <Text color={showManageState && review.isTextHidden ? "fg.muted" : "fg"} fontSize="sm" fontStyle={showManageState && review.isTextHidden ? "italic" : undefined} opacity={hidden ? 0.8 : 1} whiteSpace="pre-line" wordBreak="break-word">{text}</Text>;
    $[35] = hidden;
    $[36] = review.isTextHidden;
    $[37] = showManageState;
    $[38] = text;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== actions) {
    t21 = actions && <Box borderColor="colorPalette.border/50" borderTopWidth="1px" paddingTop={3}>{actions}</Box>;
    $[40] = actions;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t19 || $[43] !== t20 || $[44] !== t21) {
    t22 = <VStack align="stretch" gap={3}>{t19}{t20}{t21}</VStack>;
    $[42] = t19;
    $[43] = t20;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t22 || $[47] !== t5 || $[48] !== t6 || $[49] !== t7 || $[50] !== t8) {
    t23 = <Box aria-label={t5} as="article" bgColor="colorPalette.container" borderColor={t6} borderRadius="xl" borderStyle={t7} borderWidth="1px" data-hidden={t8} padding={t9} width="full">{t22}</Box>;
    $[46] = t22;
    $[47] = t5;
    $[48] = t6;
    $[49] = t7;
    $[50] = t8;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  return t23;
};